<template>
  <div class="container">
    <div @click="$emit('close')" class="close">❌</div>
    <p>De retour chez vous, vous ressortez la boite envoyée par le CEGP et le mystérieux message qui l'accompagnait afin de vous atteler à la résolution de l'énigme.</p>
  </div>
</template>

<script>

export default {
  name: "LivingRoom2Intro",
  components: {
  }
}
</script>

<style scoped>
.container {
  background: rgb(220, 220, 220);
  padding: 5px 20px;
  overflow: scroll;
  position: relative;
}
.button-wrapper {
  font-family: "VT323", monospace;
  text-align: center;
  color: white;
  background: darkred;
  line-height: 30px;
}
.button-wrapper:hover {
  opacity: 0.85;
  cursor: pointer;
}
.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.close:hover {
  cursor: pointer;
}
</style>
